<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="19.5" height="21.5" viewBox="0 0 19.5 21.5">
    <g transform="translate(-1552.25 -360.25)">
      <circle :style="{stroke:color}" class="a" cx="3" cy="3" r="3" transform="translate(1565 361)"/>
      <circle :style="{stroke:color}" class="a" cx="3" cy="3" r="3" transform="translate(1553 368)"/>
      <circle :style="{stroke:color}" class="a" cx="3" cy="3" r="3" transform="translate(1565 375)"/>
      <line :style="{stroke:color}" class="a" x2="6.83" y2="3.98" transform="translate(1558.59 372.51)"/>
      <line :style="{stroke:color}" class="a" x1="6.82" y2="3.98" transform="translate(1558.59 365.51)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "DistributeLeadIcon",
  props: {
    color: String
  }
}
</script>

<style scoped>
.a {
  fill: none;
  stroke: #fff;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.5px;
}
</style>
